import axios from "axios";
import {
  decryptAesObj,
  encryptAesObj,
} from "./CommonComponents/AESencryptdecrypt";
import config from "../config/config";

export async function checkLoginTime(current, lastTime) {
  if (lastTime) {
    const differenceInMs = current?.getTime() - lastTime?.getTime();
    let totalMiute = Math.floor(differenceInMs / 60000); // Convert milliseconds to minutes
    if (totalMiute >= config?.loginTime && totalMiute < config?.expireTime) {
      localStorage.setItem("lastUpdateTime", encryptAesObj(new Date()));
      return await regenerateToken();
    }
  }
}

async function regenerateToken() {
  await axios({
    method: "post",
    url: `${config.baseUrl}refresh-token`,
    headers: {
      Authorization:
        "Bearer " + decryptAesObj(localStorage.getItem("data"))?.token,
    },
  })
    .then((response) => {
      const newLoginData = {
        ...decryptAesObj(localStorage.getItem("data")),
        token: response?.data?.newToken,
      };
      localStorage.setItem("lastUpdateTime", encryptAesObj(new Date()))
      localStorage.setItem("data", encryptAesObj(newLoginData));
      // alert("ReGenearte Token!");
      return response;
    })
    .catch((error) => {
      console.log(error);
      return;
    });
}
